import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SessionScoreType } from '../api/studyCard';
import { StudyCard, StudyCardWithScore } from '../types/cards';

type TrainingParams = {
  isReverseMode?: boolean;
  resetAllCards?: boolean;
  onlyUnknownCards?: boolean;
};
export interface StudyCardState {
  loading?: boolean;
  error?: boolean;
  success?: boolean;
  summary?: Array<{ type: string; quantity: number }> | undefined;
  trainingSessionId?: string;
  currentCard?: StudyCard;
  sessionScore?: SessionScoreType;
  allCardsViewed?: boolean;
  cardScore?: StudyCard;
  trainingStarted?: boolean;
  trainingParams?: TrainingParams;
  currentPreviewCardIndex: number;
}

const initialState: StudyCardState = {
  loading: false,
  error: false,
  success: false,
  summary: undefined,
  trainingSessionId: undefined,
  currentCard: undefined,
  sessionScore: undefined,
  allCardsViewed: false,
  cardScore: undefined,
  trainingStarted: false,
  trainingParams: {
    isReverseMode: false,
    resetAllCards: false,
    onlyUnknownCards: false,
  },
  currentPreviewCardIndex: 0,
};

export const studyCardSlice = createSlice({
  name: 'studyCard',
  initialState,
  reducers: {
    resetState: (state) => {
      return { ...initialState };
    },
    resetTrainingSessionId: (state) => {
      return { ...state, trainingSessionId: undefined };
    },
    resetSessionScore: (state) => {
      return { ...state, sessionScore: undefined };
    },
    resetCardsViewed: (state) => {
      return { ...state, allCardsViewed: false };
    },
    resetCardScore: (state) => (state.cardScore = undefined),
    setTrainingStarted: (state, action: PayloadAction<boolean>) => {
      return { ...state, trainingStarted: action.payload };
    },
    setTrainingParams: (state, action: PayloadAction<TrainingParams>) => {
      return { ...state, trainingParams: action.payload };
    },
    setSessionScore: (state, action: PayloadAction<SessionScoreType | undefined>) => {
      return { ...state, sessionScore: action.payload };
    },
    setTrainingSessionId: (state, action: PayloadAction<string | undefined>) => {
      return { ...state, trainingSessionId: action.payload };
    },
    setCurrentCard: (state, action: PayloadAction<StudyCard | undefined>) => {
      return { ...state, currentCard: action.payload };
    },
    setCardScore: (state, action: PayloadAction<StudyCardWithScore | undefined>) => {
      return { ...state, cardScore: action.payload };
    },
    setSummary: (state, action: PayloadAction<Array<{ type: string; quantity: number }>>) => {
      return { ...state, summary: action.payload };
    },
    setCurrentPreviewCardIndex: (state, action: PayloadAction<number>) => {
      return { ...state, currentPreviewCardIndex: action.payload };
    },
  },
});

export const {
  resetTrainingSessionId,
  resetSessionScore,
  resetCardsViewed,
  resetCardScore,
  setTrainingStarted,
  setTrainingParams,
  setSessionScore,
  setTrainingSessionId,
  setCurrentCard,
  setCardScore,
  resetState,
  setSummary,
  setCurrentPreviewCardIndex,
} = studyCardSlice.actions;

export const { reducer: studyCardReducer } = studyCardSlice;
